/*
 * These are defined here instead of in `root/login`
 * since exporting them from there causes circular dependencies.
 */
export const LOGIN_FIELD_NAMES = {
    email: 'email',
    password: 'password',
    mergePassword: 'mergePassword',
    workspaceName: 'workspaceName',
};
export const LOGIN_WIZARD_STEPS = {
    EMAIL: 'email',
    PASSWORD: 'password',
    TWO_FACTOR_AUTHENTICATION: 'twoFactorAuthentication',
    TWO_FACTOR_AUTHENTICATION_EMAIL_VERIFICATION: 'twoFactorAuthenticationEmailVerification',
    TWO_FACTOR_AUTHENTICATION_RESET: 'twoFactorAuthenticationReset',
    SSO_KEY: 'ssoKey',
    MERGE: 'merge',
    WORKSPACE_NAME: 'workspaceName',
};
// Steps that belong to the two-factor authentication sub-flow. Used to avoid
// re-routing back to the TOTP gate while the user is already within it.
export const TWO_FACTOR_LOGIN_STEPS = [
    LOGIN_WIZARD_STEPS.TWO_FACTOR_AUTHENTICATION,
    LOGIN_WIZARD_STEPS.TWO_FACTOR_AUTHENTICATION_EMAIL_VERIFICATION,
    LOGIN_WIZARD_STEPS.TWO_FACTOR_AUTHENTICATION_RESET,
];
export const DEFAULT_LOGIN_STATE = {
    email: '',
    ssoKey: '',
    accessToken: '',
};
